
import { Component, Vue, Prop } from "vue-property-decorator";
import { Toast, Dialog } from "vant";
import { StoreProductService } from "src/services";
import tabbar from "src/components/tabbar";
import { tools } from "src/utils";
import { Payment_Type } from "src/enums";
import router from "src/router";

@Component
export default class PackageComponent extends Vue
{
    /**
     * 实物商品列表
     * @private
     * @returns void
     */
    private goodsList: Array<any> = [];

    /**
     * ids
     * @private
     * @returns Array<number>
     */
    private get ids()
    {
        let ids = [];
        if (localStorage.getItem("productList"))
        {
            ids = JSON.parse(localStorage.getItem("productList"));
        }
        return this.$route.params && (this.$route.params.ids) || ids;
    }

    /**
     * 实物
     * @private
     * @returns string
     */
    private get productType(): string
    {
        return this.$route.query && (this.$route.query.productType as string) || "";
    }

    /**
     * 医疗服务类型
     * @private
     * @returns string
     */
    private get type(): string
    {
        return this.$route.query && (this.$route.query.type as string) || "";
    }

    /**
     * 实物商品
     * @private
     * @returns void
     */
    protected onGoodsDetail(item: any): void
    {
        // 体检套餐 PhysicalPackage = 0
        // 医疗服务 MedicalService = 2
        // 实物 Goods = 4
        // 健管服务 HealthManageService = 6
        // 问诊购药 DiagMedicine = 2002
        // 就医绿通 Greenway = 2004
        // 齿科服务 Dental = 2006
        // 眼科服务 Eye = 2008
        // 疫苗服务 Vaccine = 2010
        // 中医服务 TCM = 2012
        // 轻医美 MedicalBeauty = 2014

        if(item.productType == 0)
        {

            // 体检套餐
            this.$router.push({name: "package-detail", query:{id: item.targetId, productId: item.id}});
        }
        else if(item.productType == 4)
        {
            // 实物套餐
            this.$router.push({name: "goodsDetail", query:{id: item.targetId, productId: item.id}});
        }
        else if(item.productType == 8)
        {
            // 健康险产品
            this.$router.push({name: "healthInsuranceDetail", query:{id: item.targetId}});
        }
        else
        {
            this.$router.push({name:"medical", query:{id:item.targetId, productId: item.id}});
        }
    }
    
    /**
     * 组件创建钩子
     * @private
     * @returns void
     */
    private created(): void
    {
        this.getHealthProductList();
    }

    /**
     * 获取实物列表
     * @private
     * @returns void
     */
    private async getHealthProductList(): Promise<void>
    {
        try
        {
            let { content: result } = await StoreProductService.instance.getStoreProduct({ids: this.ids,pageIndex: 1, pageSize: 99999});
            if(result.data)
            {
                this.goodsList = result.data.items || [];
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }
    
}
